import { useEffect, useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { brl } from "@/lib/fmt";

function Countdown({ until }) {
  const [left, setLeft] = useState(0);
  useEffect(() => {
    const tick = () => setLeft(Math.max(0, new Date(until) - Date.now()));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [until]);
  const m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
  return <span data-testid="pix-countdown" className="font-mono text-lg font-bold">{left ? `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}` : "Expirado"}</span>;
}

export const copyText = (t, msg = "Copiado") => { navigator.clipboard?.writeText(t); toast.success(msg); };

export default function PaymentPanel({ order }) {
  const pg = order.pagamento || {};
  if (order.status !== "aguardando_pagamento") {
    return <p className="rounded-2xl bg-na-sage2 p-4 text-sm font-semibold text-na-forest" data-testid="payment-status">Pagamento: {order.status === "cancelado" ? "pedido cancelado" : "confirmado"}</p>;
  }
  if (pg.gateway === "whatsapp") return <p className="text-sm text-na-ink2" data-testid="payment-status">Combine o pagamento pelo WhatsApp.</p>;
  return (
    <div className="space-y-3" data-testid="payment-panel">
      {pg.simulado && <p className="rounded-xl bg-amber-50 px-3 py-2 text-xs text-amber-800">Ambiente de teste: pagamento simulado (sandbox).</p>}
      {pg.metodo === "pix" && (
        <div className="text-center">
          <p className="text-sm text-na-ink2">Pague {brl(order.total)} com Pix em até <Countdown until={pg.expira_em} /></p>
          {pg.pix_qr && <img src={`data:image/png;base64,${pg.pix_qr}`} alt="QR Code Pix" className="mx-auto mt-3 h-48 w-48 rounded-2xl border border-na-line bg-white p-2" data-testid="pix-qr" />}
          <div className="mt-3 flex gap-2">
            <input readOnly value={pg.pix_copia_cola || ""} className="input-na text-xs" aria-label="Pix copia e cola" data-testid="pix-code" />
            <button className="btn-na shrink-0 px-4" onClick={() => copyText(pg.pix_copia_cola, "Código Pix copiado")} data-testid="pix-copy-button"><Copy className="h-4 w-4" /> Copiar</button>
          </div>
        </div>
      )}
      {pg.metodo === "boleto" && (
        <div><p className="text-sm">Linha digitável do boleto:</p>
          <div className="mt-2 flex gap-2"><input readOnly value={pg.linha_digitavel || ""} className="input-na text-xs" aria-label="Linha digitável" data-testid="boleto-line" />
            <button className="btn-na shrink-0 px-4" onClick={() => copyText(pg.linha_digitavel)} data-testid="boleto-copy-button">Copiar</button></div></div>
      )}
      {pg.metodo === "cartao" && <p className="text-sm" data-testid="card-status">Cartão em até {order.parcelas || 3}x: pagamento em análise.</p>}
    </div>
  );
}
